module.exports = __webpack_public_path__ + "img/terminal.929f6bac.svg";